import 'react-app-polyfill/ie9';
import 'core-js/stable';
import './index.css';
import React from 'react';
import {render} from 'react-dom';
import {BrowserRouter as Router} from 'react-router-dom';
import {Provider} from 'react-redux';
import store from './store';

import App from './App';

import './utils/i18n';

import './fonts/fonts.css';

render(
    <Provider store={store}>
        <Router>
            <App />
        </Router>
    </Provider>,
    document.getElementById('root'),
);
